import { Key, ReactNode } from 'react';
import { Image, Radio, RadioGroup } from '@ds';
import { columns } from './config';
import { getColorsByOrganType, getOrganImg } from '@/utils/helpers';
import { OcsConsoleData } from '@/api/apis/resources';
import { DeviceLastInUse } from './components/DeviceLastInUse/DeviceLastInUse';
import { DeviceReserveButton } from './components/DeviceReserveButton/DeviceReserveButton';
import { Uuid } from '@/api/types';

export const renderDeviceCell =
  (
    onReserve: (device: OcsConsoleData) => void,
    isLogistics: boolean,
    caseId: Uuid,
    isSwap?: boolean,
    disableReserve?: boolean,
  ) =>
  (device: OcsConsoleData & { isSelected?: boolean }, columnKey: Key): ReactNode => {
    const { id, fullSerialNumber, organType, lastInUseDaysAgo, reservations, isSelected } = device;
    const colors = getColorsByOrganType(organType);

    switch (columnKey) {
      case columns.serialNumber.key:
        return <div>{fullSerialNumber}</div>;
      case columns.organ.key:
        return (
          <div className={`${colors.bg50} w-6 h-6 rounded-full flex justify-center items-center`}>
            <Image src={getOrganImg(organType)} alt={organType} />
          </div>
        );
      case columns.lastInUse.key:
        return <DeviceLastInUse lastInUseDaysAgo={lastInUseDaysAgo} reservations={reservations} />;
      case columns.assign.key:
        return !isSwap ? (
          <DeviceReserveButton
            disabled={disableReserve}
            onReserveClick={() => onReserve(device)}
            isLogistics={isLogistics}
            reservations={reservations}
            caseId={caseId}
            isSelected={isSelected}
          />
        ) : (
          <RadioGroup onValueChange={() => onReserve(device)} value={id} isDisabled={disableReserve}>
            <Radio size="lg" value={isSelected ? 'true' : 'false'} data-selected={isSelected} />
          </RadioGroup>
        );
      default:
        return null;
    }
  };
